module.exports = __webpack_public_path__ + "static/circle-4-1560a2b958dd5c3949904a53fd191895.jpg";